function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 146,
  fill: "#edebdc",
  r: 90
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m102.428 173.428s-4.587-45.865 36.692-41.279c41.279 4.587 45.865 50.452 45.865 50.452z",
  fill: "#fc8c29"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  fill: "#4c241d"
}, /*#__PURE__*/React.createElement("path", {
  d: "m184.984 186.6c-.148 0-.293-.008-.441-.025l-82.555-9.172c-1.875-.207-3.352-1.699-3.539-3.576-.098-.967-2.219-23.85 11.156-37.078 7.176-7.1 17.25-9.984 29.957-8.574 43.984 4.889 49.352 53.537 49.402 54.027.121 1.201-.309 2.393-1.168 3.242-.753.744-1.765 1.156-2.812 1.156zm-78.699-16.768 73.887 8.209c-2.422-11.41-11.328-38.564-41.492-41.918-10.168-1.113-18.043.986-23.426 6.289-8.078 7.969-9.004 21.326-8.969 27.42z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m138 160c-2.211 0-4-1.791-4-4v-20c0-2.209 1.789-4 4-4s4 1.791 4 4v20c0 2.209-1.789 4-4 4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m150.328 159.334c-.734 0-1.477-.201-2.145-.625-1.863-1.188-2.414-3.658-1.227-5.523l9.336-14.668c1.184-1.863 3.66-2.408 5.523-1.227 1.863 1.188 2.414 3.658 1.227 5.523l-9.336 14.668c-.761 1.198-2.058 1.852-3.378 1.852z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m125.672 158.334c-1.164 0-2.316-.504-3.105-1.475l-11.668-14.334c-1.395-1.713-1.137-4.232.578-5.627 1.711-1.396 4.238-1.133 5.625.576l11.668 14.334c1.395 1.713 1.137 4.232-.578 5.627-.739.606-1.634.899-2.52.899z"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m39.924 175.721h-9.173l3.896-7.793c4.06-8.12 11.423-14.197 20.258-16.283 10.262-2.422 23.334-2.266 30.884 10.316 8.256 13.76 16.511 9.356 21.795 3.633 6.117-6.627 14.788-10.343 23.788-10.923 15.031-.969 36.565.698 53.093 14.354 4.799 3.965 10.857 6.079 17.077 5.806 17.877-.783 54.118 1.229 67.708 28.41 0 0-18.346-27.519-64.211-13.76s-45.865 22.933-96.317 0c0 0-22.933 4.587-27.519-9.173-2.811 5.622-8.557 9.173-14.842 9.173h-9.891c-7.143 0-13.484-4.571-15.743-11.347z",
  fill: "#d9be6f"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m154.406 207.424c-11.176.002-24.078-3.797-46.219-13.795-4.59.699-19.656 2.242-27.32-6.105-3.789 3.77-8.949 5.957-14.508 5.957h-9.891c-8.762 0-16.523-5.516-19.426-13.76h-6.292c-1.387 0-2.676-.719-3.402-1.896-.73-1.18-.797-2.652-.176-3.893l3.898-7.793c4.676-9.35 13.027-16.053 22.918-18.387 15.758-3.721 28.293.59 35.23 12.15 1.852 3.088 4.723 6.834 7.895 7.16 2.859.311 5.625-2.117 7.527-4.182 6.645-7.197 16.047-11.531 26.473-12.203 15.859-1.012 38.395.799 55.898 15.262 4.098 3.385 9.207 5.117 14.355 4.895 20.504-.91 57.094 1.881 71.461 30.617.945 1.891.258 4.188-1.57 5.248-1.824 1.062-4.168.52-5.336-1.24-.684-1.004-17.48-24.824-59.734-12.146-8.414 2.523-15.215 4.873-21.215 6.945-12.257 4.234-20.746 7.166-30.566 7.166zm-45.683-21.944c.566 0 1.133.121 1.656.359 39.656 18.027 46.504 15.658 71.98 6.857 6.074-2.098 12.957-4.477 21.531-7.049 11.5-3.447 21.402-4.445 29.77-3.943-11.414-2.957-23.273-3.262-31.941-2.879-7.105.307-14.18-2.07-19.805-6.721-15.48-12.791-35.891-14.367-50.285-13.443-8.367.539-15.863 3.965-21.109 9.645-5.691 6.176-10.863 7.062-14.227 6.715-5.188-.533-9.875-4.236-13.934-11.002-5.145-8.568-14.059-11.426-26.535-8.482-7.574 1.789-13.988 6.957-17.598 14.18l-1.004 2.004h2.699c1.723 0 3.25 1.102 3.793 2.734l.805 2.412c1.723 5.152 6.523 8.613 11.949 8.613h9.891c4.801 0 9.117-2.668 11.266-6.963.723-1.445 2.191-2.307 3.863-2.201 1.613.115 3 1.191 3.508 2.725 3.383 10.127 22.746 6.555 22.941 6.518.262-.053.524-.079.786-.079z",
  fill: "#4c241d"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m50.855 179.721h-16.105c-2.211 0-4-1.791-4-4s1.789-4 4-4h16.105c2.211 0 4 1.791 4 4s-1.789 4-4 4z",
  fill: "#4c241d"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m134.534 187.187s4.587 32.106 32.106 27.519l4.587 4.587-5.227 8.707c-6.627 0-12 5.373-12 12h20l10.985-20.707s-13.76-9.173-13.76-27.519",
  fill: "#d9be6f"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m174 244h-20c-2.211 0-4-1.791-4-4 0-8.018 5.93-14.676 13.629-15.824l2.559-4.264-.969-.971c-7.66.85-14.391-.814-20.047-4.955-11.977-8.768-14.496-25.523-14.598-26.232-.312-2.186 1.203-4.205 3.387-4.521 2.184-.307 4.215 1.197 4.531 3.381.023.143 2.184 14.195 11.438 20.941 4.418 3.227 9.676 4.275 16.055 3.207 1.266-.225 2.566.201 3.484 1.117l4.586 4.586c1.297 1.297 1.547 3.312.602 4.887l-5.227 8.707c-.723 1.205-2.023 1.941-3.43 1.941-2.957 0-5.543 1.611-6.926 4h12.52l8.316-15.674c-4.5-4.072-12.684-13.543-12.684-28.553 0-2.209 1.789-4 4-4s4 1.791 4 4c0 15.865 11.504 23.869 11.992 24.201 1.688 1.146 2.254 3.391 1.301 5.193l-10.984 20.707c-.695 1.308-2.055 2.126-3.535 2.126z",
  fill: "#4c241d"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m125.361 178.014s4.587 13.76-9.173 13.76l-13.76 9.173 2.676 2.676c3.588 3.588 3.588 9.406 0 12.995l-2.676 2.676-16.053-16.054 16.053-20.639",
  fill: "#d9be6f"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m102.43 223.293c-1.023 0-2.047-.391-2.828-1.172l-16.055-16.053c-1.426-1.426-1.566-3.691-.328-5.283l16.055-20.641c1.355-1.74 3.867-2.057 5.613-.703 1.742 1.357 2.055 3.871.699 5.613l-13.887 17.854 10.727 10.725c1.871-2.031 1.82-5.209-.148-7.182l-2.676-2.676c-.848-.848-1.27-2.029-1.152-3.223.117-1.191.766-2.27 1.762-2.934l13.758-9.174c.656-.438 1.43-.672 2.219-.672 2.566 0 4.277-.566 5.094-1.682 1.402-1.926.652-5.672.277-6.832-.676-2.096.469-4.352 2.559-5.037 2.066-.688 4.34.436 5.035 2.525.285.848 2.645 8.436-1.375 14.008-1.539 2.139-4.562 4.658-10.328 4.982l-8.777 5.855c4.387 5.176 4.145 12.969-.738 17.852l-2.676 2.676c-.784.783-1.807 1.174-2.83 1.174z",
  fill: "#4c241d"
});

var _ref12 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 64,
  cy: 166,
  fill: "#4c241d",
  rx: 2.766,
  ry: 2.555
});

function SvgDino01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dino30",
    enableBackground: "new 0 0 300 300",
    height: 512,
    viewBox: "0 0 300 300",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDino01);
export default __webpack_public_path__ + "static/media/dino-01.2a174758.svg";
export { ForwardRef as ReactComponent };